var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('v-text-field',{attrs:{"outlined":"","label":"Поиск"},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }